import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

const initialState = {
  markets: [],
  fancies: [],
  favMarketIds: [],
  loading: false,
  error: null,
};

export const fetchMultiMarketDetails = createAsyncThunk(
  "multiMarket/fetchMultiMarketDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/match/matchDetailsFav", {
        combine: true,
      });
      const raw = response?.data ?? response;
      return Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Multi-market details fetch failed",
      );
    }
  },
);

export const fetchMultiMarketFancy = createAsyncThunk(
  "multiMarket/fetchMultiMarketFancy",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/fancy/getFanciesFav", {
        combine: true,
      });
      const raw = response?.data ?? response;
      return Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Multi-market fancy fetch failed",
      );
    }
  },
);

const multiMarketSlice = createSlice({
  name: "multiMarket",
  initialState,
  reducers: {
    clearMultiMarket: (state) => {
      state.markets = [];
      state.fancies = [];
      state.favMarketIds = [];
      state.loading = false;
      state.error = null;
    },
    toggleFavMarketId: (state, action) => {
      const { id, isAdd } = action.payload;
      const idStr = String(id);
      let nextIds = [...state.favMarketIds];
      if (isAdd) {
        if (!nextIds.includes(idStr)) {
          nextIds.push(idStr);
        }
      } else {
        nextIds = nextIds.filter((favId) => favId !== idStr);
      }
      state.favMarketIds = nextIds;
    },
    refreshFavMarketIds: (state) => {
      state.favMarketIds = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMultiMarketDetails.pending, (state) => {
        // Keep polling refresh silent once initial data exists.
        state.loading = state.markets.length === 0 && state.fancies.length === 0;
        state.error = null;
      })
      .addCase(fetchMultiMarketDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.markets = action.payload;
      })
      .addCase(fetchMultiMarketDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMultiMarketFancy.fulfilled, (state, action) => {
        state.fancies = action.payload;
      });
  },
});

export const { clearMultiMarket, toggleFavMarketId, refreshFavMarketIds } =
  multiMarketSlice.actions;
export default multiMarketSlice.reducer;
